import styled from 'styled-components';

export const MainWrapper = styled.div`
  width: fit-content;
`;

export const FieldsInfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  height: fit-content;
  .middle-width-item {
    width: 380px;
  }
`;

export const EducationColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 20px;
  height: fit-content;
`;


export const ComponentWrapper = styled.div`
  width: 100%;
  & > div:first-child {
    display: flex;
    margin: 16px 0;
  }
`;

export const EducationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  & > div:first-child {
    max-width: 800px;
  }
`;

export const SkillsContainer = styled.div`
  display: flex;
`;

export const AccessWrapper = styled.div`
  & > div:first-child {
    display: flex;
    margin: 16px 0;
  }
`;

export const DeleteContainer = styled.div<{ isIcon: boolean }>`
  display: flex;

  ${({ isIcon }) =>
    isIcon &&
    `
    & > div:last-child {
        cursor: pointer;
        margin-left: 18px;
        margin-top: 7px;
    }
  `}
`;

export const FormListWrapper = styled.div<{ isIcon: boolean; isSalary?: boolean }>`
  display: flex;
  flex-direction: column;

  & > div:last-child {
    margin-top: ${({ isSalary }) => (isSalary ? 0 : '10px')};
    margin-right: ${({ isIcon }) => (isIcon ? '40px' : 0)};
    align-self: flex-end;

    .ant-btn {
      padding: 0;
    }
  }

  ${({ isSalary }) =>
    !isSalary &&
    `
    & > div:first-child { 
      margin-bottom: 16px;
    }  
    `}
`;
